import React from 'react'
import Sidebar from './Sidebar'

const Layout = ({ children }) => {
  return (
    <div class="layout-wrapper layout-content-navbar">
        <div class="layout-container">
            <Sidebar/>
            {children}
        </div>
    </div>
  )
}

export default Layout
